import toast from 'react-hot-toast';
import { ensureIntercomBooted, showIntercom } from '../../../utils/intercom';

/** Open the app-level assistant in its full workspace. */
export function openAssistant() {
  window.dispatchEvent(new CustomEvent('lodgeic:assistant:open', { detail: { expanded: true } }));
}

/** Open the Intercom messenger (its own launcher is hidden app-wide). */
export async function openSupport() {
  const ready = await ensureIntercomBooted();
  if (!ready || !showIntercom()) {
    toast.error('Support chat is unavailable right now. Email support@lodgeic.io.');
  }
}

/** Ask the shell to open the command palette (⌘K). */
export function openCommandPalette() {
  window.dispatchEvent(new CustomEvent('lodgeic:command-palette:open'));
}
